/**
 * Helpers de entorno (producción vs staging).
 * Usado por StagingBanner; en build producción los defaults apuntan a nexopos-dc.
 */

const rawEnv = String(process.env.REACT_APP_ENV || 'production').trim().toLowerCase();

export const APP_ENV = rawEnv === 'staging' ? 'staging' : 'production';

export function isStagingEnv() {
  return APP_ENV === 'staging';
}

export function isProductionEnv() {
  return APP_ENV === 'production';
}

export function getPublicAppUrl() {
  const fallback = isStagingEnv()
    ? 'https://nexopos-dc-staging.web.app'
    : 'https://nexopos-dc.web.app';
  return String(process.env.REACT_APP_PUBLIC_APP_URL || fallback).trim().replace(/\/$/, '');
}

export function getFirebaseProjectId() {
  return String(
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
      (isStagingEnv() ? 'nexopos-dc-staging' : 'nexopos-dc')
  ).trim();
}

/** true si staging apunta por error al proyecto de producción */
export function isStagingMisconfigured() {
  return isStagingEnv() && getFirebaseProjectId() === 'nexopos-dc';
}
